import request from '../../utils/request';
import {paramSecret} from "../../utils/commonSecret";


// 获取盲盒信息
export async function getBlindBoxInfoByNumber(params) {
    return request('/api/v2/front/blindBox/getBlindBoxInfoByNumber',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 领取盲盒奖品
export async function receiveByUserInfo(params) {
    return request('/api/v2/front/blindBox/receiveByUserInfo',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}
